<template>
    <!-- toggle and nav items -->
    <ul class="navbar-nav mr-auto mt-md-0">
        <li class="nav-item m-l-10">
            <a
                    class="nav-link sidebartoggler text-muted"
                    @click="handleSidebarToggle"
            >
                <i style="font-size: 20px;color: #ccc;cursor:pointer;" class="fas fa-bars" ></i>
            </a>
        </li>
        <!-- Messages -->
        <li
            class="nav-item dropdown mega-dropdown"
            :class="{'show': isMegaDropDown, '': !isMegaDropDown }"
            @click="handleMegaDropDown"
        >
            <a
                class="nav-link dropdown-toggle text-muted"
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"><i class="fa-light fa-headset" ></i> <span v-if="!isMobile" style="color: #fff;">CONTACT US</span>
            </a>
            <div
                class="dropdown-menu animated zoomIn"
                :class="{'show': isMegaDropDown, '': !isMegaDropDown }"
                @click="handleMegaDropDown"
            >
                <ul class="mega-dropdown-menu row">
					<ContactUs ref="contactus" :caller="'topheader'"  @close="isMegaDropDown = !isMegaDropDown;"></ContactUs>
                </ul>
            </div>
        </li>
        <!-- End Messages -->
    </ul>
</template>

<script>
import axios from 'axios';
import Util from '../../assets/js/util.js';
import ContactUs from './ContactUs.vue';
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

    export default{
        data() {
            return {
                clickable: true,
                isMegaDropDown: false,
                contactDetails: {},
				showContactUsForm : true,
                isMobile : false,
            }
        },
        props: {
            isCollapse: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        emits: ['collapse'],
        components: {
            ContactUs
        },
        methods: {
            toggle(e){
                e.target.parentElement.classList.toggle('close')
            },
            handleSidebarToggle(){
                if( this.clickable ){
                    this.clickable = false;
                    document.body.classList.toggle('mini-sidebar');
                    let collapse = document.body.classList.contains('mini-sidebar');
	                this.$emit('collapse', {isCollapse: collapse});
                    this.clickable = true;
                }
            },
            handleMegaDropDown (e) {
              this.isMegaDropDown = !this.isMegaDropDown;
            },
		    submit() {
                if (this.currentStatus == STATUS_SAVING) {
                    return true;
                }
				this.$refs['contactUsForm'].validate((valid) => {
					if (valid) {
						this.currentStatus = STATUS_SAVING;
						axios.post('/Index/ContactUs', {
							message: this.contactDetails
						}).then(response => {
							this.currentStatus = STATUS_INITIAL;
							if (response.data.result == 'success') {
								this.$notify({
									title: 'Success',
									message: "Message has been sent. Someone will contact you shortly.",
									type: 'success',
									duration: 3000,
									showClose: false
								});
				                this.isMegaDropDown = false;
                                this.contactDetails = {'ContactName': '', 'ContactEmailAddress': '', 'ContactMessage': ''};
			                } else {
								this.$notify({
									title: 'Error',
									message: (response.data.message ? response.data.message : 'Submission could not be processed'),
									type: 'error',
									duration: 2000,
									showClose: false
								});
			                }
						}).catch(response => {
							this.currentStatus = STATUS_FAILED;
						});
                    } else {
                        return false;
                    }
                });
		    },
        },
        mounted () {
            this.isMobile = Util.isMobile();
        }
    }
</script>
<style>
.form-control {
	width: 100%;
}
textarea.form-control {
	height: 100px;
}
.mega-dropdown-menu .el-form--label-top .el-form-item__label {
	margin:0;
	padding:0;
	line-height: 20px;
}
</style>
